import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';
import { fetchProject } from '../../redux/actions/project';



const Collections=({dispatch, data})=> {
data.sort((a,b)=>a.projectname.toLowerCase().trim().localeCompare(b.projectname.toLowerCase().trim()))

    useEffect(()=>{
        dispatch(fetchProject())
       },[dispatch])


   
        return (
            
            <section id='explore' className="popular-collections-area mt-5 p-0">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            {/* Intro */}
                            <div className="intro d-flex justify-content-between align-items-end m-0">
                                <div className="intro-content">
                                    <span>View Reviews</span>
                                    <h3 className="mt-3 mb-0">Explore NFTs</h3>
                                </div>
                                {/* <div className="intro-btn">
                                    <Link className="btn content-btn text-left" to="/explore-2">View All</Link>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    <div className="row items">
                        {data && data.map((item, idx) => {
                            return (
                                <div key={`cd_${idx}`} className="col-12 col-sm-6 col-lg-3 item">
                                    <div className="card no-hover text-center">
                                        <div className="image-over">
                                            <Link to={'/project/'+item._id}>
                                                <img height={180} className="card-img-top" src={item.image} alt="" />
                                            </Link>
                                            {/* Seller */}
                                            <Link className="seller" to={'/project/'+item._id}>
                                                <div className="seller-thumb avatar-lg">
                                                    <img className="rounded-circle" src={item.image} alt="" />
                                                </div>
                                            </Link>
                                        </div>
                                        {/* Card Caption */}
                                        <div className="card-caption col-12 p-0">
                                            {/* Card Body */}
                                            <div className="card-body mt-4">
                                                <Link to={'/project/'+item._id}>
                                                    <h5 className="mb-2">{item.projectname}</h5>
                                                </Link>
                                                <div className='two-col-div d-flex mt-2 mb-2'>
                                                    <div className="col-6 first-div-border-right">
                                                        <span>{item.mintPrice}</span> <br />
                                                        <span>Mint Price</span>

                                                    </div>
                                                    <div className="col-6">
                                                    <span>{item.mintRevenue}</span> <br />
                                                    <span>Revenue</span>
                                                    </div>

                                                </div>
                                                <span>{item.description.slice(0,160)}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {/* <div className="row">
                        <div className="col-12 text-center">
                            <a id="load-btn" className="btn btn-bordered-white mt-5" href="#more">Load More</a>
                        </div>
                    </div> */}

                </div>
            </section>
        );
   
}

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    
    data: state.project.projectData
  };
}

export default connect(mapStateToProps)(Collections);